import {combineReducers} from 'redux';
import {getSuccessActionType} from '../utils';
import {getErrorReducer, getStatusReducer} from './utils/generators';
import {
  END_STUDENT_COURSE,
  START_STUDENT_COURSE,
  FETCH_STUDENT_COURSE
} from '../constants/student-course';

function data(state = {}, action) {
  switch (action.type) {
    case getSuccessActionType(FETCH_STUDENT_COURSE):
      return action.payload;

    case getSuccessActionType(START_STUDENT_COURSE):
      return action.payload;

    case getSuccessActionType(END_STUDENT_COURSE):
      return {};

    default:
      return state;
  }
}

const actionTypes = [
  FETCH_STUDENT_COURSE,
  START_STUDENT_COURSE,
  END_STUDENT_COURSE
];

export default combineReducers({
  status: getStatusReducer(actionTypes),
  error: getErrorReducer(actionTypes),
  data
});
